import * as React from 'react';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { TabBrandingHOC } from '../../hocs/TabBrandingHOC';

export function TabBrandingContext() {
    const { boardId } = React.useContext(AsidePanelContext);
    return <TabBrandingHOC boardId={boardId}/>
}
